export class ClassItem {
  classId: number;
  className: string;
  constructor(data: any) {
    this.classId = data.classId;
    this.className = data.className;
  }
}